import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { deepDiffMapper } from '../../game_functions/functions';
import { moveBackToResultsPhase, moveBackToActiveWithParams } from '../../../../../store/actions/gameActions';
import Typography from '@material-ui/core/Typography';
import styles from '../../../../Styles';
import ActivityListPlus from '../specific_components/activityListPlus';
import ActivityListDelta from '../specific_components/activityListDelta';
import ActivityListPlusTwo from '../specific_components/activityListPlusTwo';
import ActivityListDeltaTwo from '../specific_components/activityListDeltaTwo';
import AddIcon from '@material-ui/icons/Add';
import goldf from '../images/goldf.png'
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image,
    PDFViewer,
    PDFDownloadLink
  } from "@react-pdf/renderer";
import ChangeHistoryIcon from '@material-ui/icons/ChangeHistory';
import { PDFHeader } from './../../../../PastData/PDFHeader';

const INITIAL_STATE = {
    open: false
};

class GameResults extends Component {

    constructor(props) {
        super(props);
        this.state = {
          ...INITIAL_STATE,
        };
    }



    componentDidMount() {
        window.scrollTo(0, 0);
        this.setState({
            ...this.state,
            diff: deepDiffMapper.map(this.props.results.resultSnapshot === undefined ? {} : this.props.results.resultSnapshot, this.props.results.results)
        })
    }


    handleClickOpen = () => {
        this.setState({
            ...this.state,
            open: true
        });
    };
    
    handleClose = () => {
        this.setState({
            ...this.state,
            open: false
        });
    };

    render() {
    const {
      results,
      classes,
      profiles
    } = this.props;

    
        const PLUS = "solutions";
        const DELTA = "challenges";
        const PLUS_TWO = "success";
        const DELTA_TWO = "your_role";
        const regex = /<br[^>]*>/gi;



        if ( this.props.isPDFView === true ){

            return (
                <Document>
                    <Page wrap style={{padding: "30 0"}}>
                        <PDFHeader/>
                        <View>
                            <Image style={{marginHorizontal: "150", marginBottom: "30"}} src={goldf}/>
                            <View style={{marginHorizontal: "50", marginBottom: "50", fontSize: "12pt"}}>
                                <Text variant="h6">Questions</Text>
                                <Text variant="body1">1. What types of universal learning will benefit cross functional areas? (Consider curriculum for a broader audience.)</Text> 
                                <Text variant="body1">2. What needs to be in place to ensure success of the project and the final University learning?</Text>
                                <Text variant="body1">3. What potential obstacles will get in the way of success and how will you overcome these things?</Text>
                                <Text variant="body1">4. How are you willing to support the learning structure of Architectural University?</Text>   
                            </View>
                        {Object.keys(results.results)
                        .sort()
                        .map((groupKey, ind) => {
                            
                                return (
                            <React.Fragment key={ind}>
                                    <View style={{marginHorizontal: "50", marginBottom: "50"}} wrap={false}>
                                        <Text style={{marginBottom: "10", fontSize: "20pt"}}>{results.groups[groupKey].title}</Text>                                    
                         
                                      
                                        <View  style={{marginVertical: "5", flexDirection: "row"}}>                                                
                                            <View style={{ flex: 1, fontSize: "12pt", marginRight: "10", border: "1pt solid #000"}}  wrap={false}>
                                                <View style={{backgroundColor: "#673ab7", padding: "10", textAlign: "center"}}><Text style={{color: "#fff"}}>Solutions (#1)</Text></View>
                                                <View style={{padding: "10" }}>
                                                    {
                                                     results.results[groupKey].hasOwnProperty(PLUS)
                                                        ? results.results[groupKey][PLUS].map((item, index) => {
                                                            return (
                                                                <Text key={index} style={{padding: "6 0"}}>                 
                                                                - {item.replace(regex, "\n")}                                 
                                                                </Text>
                                                            )
                                                        })
                                                        : null
                                                    }    
                                               </View>
                                            </View>
                                            <View style={{ flex: 1, fontSize: "12pt", marginLeft: "10", border: "1pt solid #000"}}  wrap={false}>
                                                <View style={{backgroundColor: "#673ab7", padding: "10", textAlign: "center"}}><Text style={{color: "#fff"}}>Success (#2)</Text></View>
                                                <View style={{padding: "10" }}>
                                                    {
                                                     results.results[groupKey].hasOwnProperty(PLUS_TWO)
                                                        ? results.results[groupKey][PLUS_TWO].map((item, index) => {
                                                            return (
                                                                <Text key={index} style={{padding: "6 0"}}>                 
                                                                - {item.replace(regex, "\n")}                                 
                                                                </Text>
                                                            )
                                                        })
                                                        : null
                                                    }    
                                               </View>
                                            </View>
                                        </View>

                                        <View  style={{marginVertical: "5", flexDirection: "row"}}>                                                
                                            <View style={{ flex: 1, fontSize: "12pt", marginRight: "10", border: "1pt solid #000"}}  wrap={false}>
                                                <View style={{backgroundColor: "#673ab7", padding: "10", textAlign: "center"}}><Text style={{color: "#fff"}}>Challenges (#3)</Text></View>
                                                <View style={{padding: "10" }}>
                                                    {
                                                     results.results[groupKey].hasOwnProperty(DELTA)
                                                        ? results.results[groupKey][DELTA].map((item, index) => {
                                                            return (
                                                                <Text key={index} style={{padding: "6 0"}}>                 
                                                                - {item.replace(regex, "\n")}                                 
                                                                </Text>
                                                            )
                                                        })
                                                        : null
                                                    }    
                                               </View>
                                            </View>
                                            <View style={{ flex: 1, fontSize: "12pt", marginLeft: "10", border: "1pt solid #000"}}  wrap={false}>
                                                <View style={{backgroundColor: "#673ab7", padding: "10", textAlign: "center"}}><Text style={{color: "#fff"}}>Your Role (#4)</Text></View>
                                                <View style={{padding: "10" }}>
                                                    {
                                                     results.results[groupKey].hasOwnProperty(DELTA_TWO)
                                                        ? results.results[groupKey][DELTA_TWO].map((item, index) => {
                                                            return (
                                                                <Text key={index} style={{padding: "6 0"}}>                 
                                                                - {item.replace(regex, "\n")}                                 
                                                                </Text>
                                                            )
                                                        })
                                                        : null
                                                    }    
                                               </View>
                                            </View>
                                        </View>
                                        
                                     
                                    </View>
                                </React.Fragment>       
                                );
                            
                        })}
                        </View>
                    </Page>
                </Document> 
            )
        }

        return (
        <div>
            <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
                <Typography variant="h3">{results.name}</Typography>
                <Typography variant='h5' className={classes.spaceBottom}>
                    Debrief
                </Typography>

                <Typography variant="h6">Questions</Typography>
                <Typography variant="body1">1. What types of universal learning will benefit cross functional areas? (Consider curriculum for a broader audience.)</Typography> 
                <Typography variant="body1">2. What needs to be in place to ensure success of the project and the final University learning?</Typography>
                <Typography variant="body1">3. What potential obstacles will get in the way of success and how will you overcome these things?</Typography>
                <Typography variant="body1">4. How are you willing to support the learning structure of Architectural University?</Typography>   
                { /*: null */ }
            </Grid>
            <Grid item xs={12} sm={12}>
                {Object.keys(results.results)
                .sort()
                .map((groupKey, ind) => {
                    return (
                    <div key={ind}>
                        <Typography variant="h4" className={`${classes.spacingTop} ${classes.spacingBottom}`}>{results.groups[groupKey].title}</Typography>
                        <Grid container spacing={2}>                                  
                            <Grid item xs={12} sm={6}>
                                <Grid item xs={12}  align="center" className={classes.tableHead}>  
                                    Solutions (#1)
                                </Grid>
                                <Grid item xs={12}  align="center" className={classes.tableBody}>
                                    <ActivityListPlus results={results} group_id={groupKey} debrief={true} hasGameControl={false} showList={true}/>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Grid item xs={12}  align="center" className={classes.tableHead}>   
                                    Challenges (#3)  
                                </Grid>  
                                <Grid item xs={12}  align="center" className={classes.tableBody}>
                                    <ActivityListDelta results={results} group_id={groupKey} debrief={true} hasGameControl={false} showList={true} />     
                                </Grid>  
                            </Grid>  
                        </Grid>
                        <Grid container spacing={2}>        
                            <Grid item xs={12} sm={6}>
                                <Grid item xs={12}  align="center" className={classes.tableHead}>  
                                    Success (#2)
                                </Grid>
                                <Grid item xs={12}  align="center" className={classes.tableBody}>
                                    <ActivityListPlusTwo results={results} group_id={groupKey} debrief={true} hasGameControl={false} showList={true}/>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                            <Grid item xs={12}  align="center" className={classes.tableHead}>   
                                    Your Role (#4)  
                                </Grid>  
                            <Grid item xs={12}  align="center" className={classes.tableBody}>
                                    <ActivityListDeltaTwo results={results} group_id={groupKey} debrief={true} hasGameControl={false} showList={true} />     
                            </Grid>  
                            </Grid>  
                        </Grid>
                    </div>
                    );
                })}
            </Grid>
            </Grid>
        </div>
        );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    moveBackToResultsPhase : (session,host) => dispatch(moveBackToResultsPhase(session,host)),
    moveBackToActiveWithParams : (session,host,params) => dispatch(moveBackToActiveWithParams(session,host,params))
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(GameResults);
